// this is an auto generated file. This will be overwritten

export const createNotification = /* GraphQL */ `
  mutation CreateNotification($input: CreateNotificationInput!) {
    createNotification(input: $input) {
      ID
      UserID
      TeamID
      Type
      IconType
      IsRead
      Title
      Content
      ActivityID
      LeadID
      LeadName
      RecruitingStatus
      InboxConversationID
      InboxMessageID
      CreatedAt
      __typename
    }
  }
`;
export const updateReadStatus = /* GraphQL */ `
  mutation UpdateReadStatus($input: UpdateReadStatusInput!) {
    updateReadStatus(input: $input) {
      ID
      UserID
      TeamID
      Type
      IconType
      IsRead
      Title
      Content
      ActivityID
      LeadID
      LeadName
      RecruitingStatus
      InboxConversationID
      InboxMessageID
      CreatedAt
      __typename
    }
  }
`;
export const markAllAsRead = /* GraphQL */ `
  mutation MarkAllAsRead($UserID: Int!, $TeamID: Int!, $Type: String) {
    markAllAsRead(UserID: $UserID, TeamID: $TeamID, Type: $Type) {
      CurrentEpoch
      Success
      __typename
    }
  }
`;
